<div class="mobile-header mobile-header--stuck mobile-header--shown" #element *ngIf="isShow">
    <div class="mobile-header__panel" #panelElement>
        <div class="container p-0">
            <div class="mobile-header__body">
                <button class="mobile-header__menu-button" (click)="menu.open()">
                    <app-icon name="menu-18x14" size="18x14"></app-icon>
                </button>
                <a class="mobile-header__logo" href="http://www.home-connect.co.za/">
                    <img height="30px" width="100px" src="../../../../../assets/images/megamenu/Main_logo.png" alt="">
                </a>
                <div class="mobile-header__indicators">
                    <div class="d-flex">
                        <div *ngIf="!this.sharedDataService.getValue('addressChangedata') && (currentUrl === '/checkcoverage/packages') &&
                        [configuration.Frogfoot,configuration.Vumatel,configuration.MetroFibreNetworx, configuration.Openserve,configuration.Balwin,
                        configuration.Netstream,configuration.CenturyCityConnect,configuration.WaterfallView,configuration.Octotel,configuration.DNATel,configuration.LinkLayer,configuration.WaterfallAccessNetworks
                        ]
                        .includes(activeUserStorage.getValue('serviceProviderId'))" class="ping ping_mobile"
                            matTooltip='Info' matTooltipPosition="below" matTooltipClass="sidebar_tooltip"
                            (click)="toggleDrawer()">i
                        </div>
                        <div class="indicator indicator--mobile-search indicator--mobile d-md-none support-icon-img">
                            <button class="indicator__button">
                                <span (click)="checkCoverage()" class="indicator__area">
                                    <img class="down-up"
                                        src="../../../../assets/images/providersImg/Artboard 1 copy 4.svg"
                                        height="25px">
                                </span>
                            </button>
                        </div>
                        <!-- <img class="down-up cursor-pointer" src="../../../../assets/images/providersImg/Artboard 1 copy 7.svg" height="30px"> -->
                        <app-indicator *ngIf="!personIcon() && !userImage" link="./account" icon="person-21"
                            style="margin-top:10px " trigger="click" #accountIndicator="appIndicator">
                            <app-account-menu (closeMenu)="accountIndicator.close(true)"></app-account-menu>
                        </app-indicator>

                        <app-indicator *ngIf="personIcon() || userImage" link="./account" icon="person-image"
                            trigger="click" #accountIndicator="appIndicator">
                            <app-account-menu (closeMenu)="accountIndicator.close(true)"></app-account-menu>
                        </app-indicator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>